/* Oferta relâmpago do carrinho.
   O box já vem renderizado em Liquid por snippets/cart-flash.liquid; aqui só
   decidimos se ele aparece, cuidamos do cronômetro e do add ao carrinho.

   Sobre o preço: quem desconta é um desconto automático "compre X, leve Y" do
   Shopify, aplicado no carrinho. O tema não consegue ler esse desconto, então o
   percentual vem da configuração (flash_desconto_pct) e o Liquid já renderiza o
   preço final. Daí as três checagens desta lista que existem só para o box não
   prometer o que o carrinho não aplica:

     - GATILHO: sem um dos produtos do "compre X", o Y entra sem desconto.
     - MAX: acima do gatilho do brinde por valor, o Shopify aplica um desconto
       de produto por pedido e escolhe o melhor para o cliente — o brinde ganha
       e esta oferta é ignorada.
     - o produto já estar no carrinho. */
(function () {
  'use strict';

  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-cart-flash]'));
  if (!boxes.length) return;

  var ref = boxes[0];
  var VARIANTE = ref.getAttribute('data-flash-variant');
  var PRODUTO = parseInt(ref.getAttribute('data-flash-product'), 10) || 0;
  var MIN = parseInt(ref.getAttribute('data-flash-min'), 10) || 0;
  var MAX = parseInt(ref.getAttribute('data-flash-max'), 10) || 0;
  var MINUTOS = parseInt(ref.getAttribute('data-flash-timer'), 10) || 0;

  /* Produtos que fazem o desconto do Shopify valer. Vazio = sem gatilho. */
  var GATILHO = (ref.getAttribute('data-flash-gatilho') || '')
    .split(',').map(Number).filter(Boolean);

  var CHAVE = 'lof_flash_' + VARIANTE;
  var tick = null;

  /* sessionStorage, nao localStorage: a contagem vale por VISITA. Com
     localStorage, quem navegasse 10 minutos sem comprar perdia a oferta para
     sempre, em toda visita futura — e a nota do box promete o contrario
     ("valida enquanto este carrinho estiver aberto"). Assim quem volta amanha
     ganha uma janela nova, e a urgencia continua existindo dentro da visita.

     Storage pode lançar (janela privada, cookies bloqueados) e pode voltar
     vazio. Nos dois casos o cronômetro recomeça — preferimos isso a esconder a
     oferta de quem não tem storage. */
  function ler() {
    try { return parseInt(window.sessionStorage.getItem(CHAVE), 10) || 0; }
    catch (e) { return 0; }
  }
  function gravar(ts) {
    try { window.sessionStorage.setItem(CHAVE, String(ts)); } catch (e) {}
  }

  function dois(n) { return n < 10 ? '0' + n : String(n); }

  function pintarRelogio(restante) {
    var txt = dois(Math.floor(restante / 60)) + ':' + dois(restante % 60);
    boxes.forEach(function (box) {
      var alvo = box.querySelector('[data-flash-clock-value]');
      var linha = box.querySelector('[data-flash-clock]');
      if (alvo) alvo.textContent = txt;
      if (linha) linha.hidden = false;
    });
  }

  function esconder() {
    boxes.forEach(function (box) { box.classList.add('hidden'); });
    if (tick) { clearInterval(tick); tick = null; }
  }

  function mostrar() {
    boxes.forEach(function (box) { box.classList.remove('hidden'); });
  }

  /* Cronômetro: começa a contar na primeira vez que a oferta fica elegível, não
     no primeiro acesso ao site — senão o cliente que só volta depois nunca vê
     a oferta. Quando zera, o box some pelo resto da visita. */
  function cuidarDoTempo() {
    if (!MINUTOS) { mostrar(); return; }

    var fim = ler();
    if (!fim) {
      fim = Date.now() + MINUTOS * 60000;
      gravar(fim);
    }

    var restante = Math.round((fim - Date.now()) / 1000);
    if (restante <= 0) { esconder(); return; }

    mostrar();
    pintarRelogio(restante);

    if (tick) clearInterval(tick);
    tick = setInterval(function () {
      var r = Math.round((ler() - Date.now()) / 1000);
      if (r <= 0) { esconder(); return; }
      pintarRelogio(r);
    }, 1000);
  }

  function avaliar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* A oferta é para quem já colocou algo no carrinho. */
        if (!c.items.length) { esconder(); return; }

        /* Já está no carrinho: nada a oferecer. */
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].product_id === PRODUTO) { esconder(); return; }
        }

        if (MIN > 0 && c.total_price < MIN) { esconder(); return; }

        /* Teto: acima dele o desconto automatico da oferta perde para o brinde
           por valor — o Shopify aplica um desconto de produto por pedido e
           escolhe o melhor para o cliente. Sem o teto, o box prometeria um
           desconto que o carrinho nao aplica. */
        if (MAX > 0 && c.total_price > MAX) { esconder(); return; }

        /* Gatilho: o desconto do Shopify e um "compre X, leve Y". Sem um X no
           carrinho, o Y entra sem desconto nenhum. */
        if (GATILHO.length) {
          var temGatilho = false;
          for (var g = 0; g < c.items.length; g++) {
            if (GATILHO.indexOf(c.items[g].product_id) !== -1) { temGatilho = true; break; }
          }
          if (!temGatilho) { esconder(); return; }
        }

        cuidarDoTempo();
      })
      .catch(function () {});
  }

  /* Delegado no documento: na página de carrinho o HTML é reescrito pelo
     servidor a cada alteração. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-flash-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var rotulo = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando…';

    var naPagina = !!btn.closest('.lof-flash-page');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-flash-add')), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        if (naPagina) { window.location.reload(); return; }
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) toggle.click();
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = rotulo;
      });
  });

  /* O theme.js reescreve o subtotal a cada mudança do carrinho: usamos como
     gatilho, igual cart-recs.js, sem precisar mexer naquele arquivo. */
  var subtotal = document.querySelector('[data-cart-subtotal]');
  if (window.MutationObserver && subtotal) {
    new MutationObserver(avaliar).observe(subtotal, { childList: true, characterData: true, subtree: true });
  }
  avaliar();
})();